import React from "react"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import { ELanguage, IQuestion, } from "../../models"
import { Dialog, FlatButton, TextField } from "material-ui"
import moment from "moment"
import _ from "lodash"
import HTMLEditText from "../common/html_edit_text/HTMLEditText"
import { EnumValues } from "enum-values"
interface IProps {
    question: IQuestion
    handleUpdate(question: IQuestion): void
    handleClose(): void
}
interface IState {
    modified: boolean
    title: string
    errTitle: string
    question: string
    errQuestion: string
    btn1: string
    errBtn1: string
    btn2: string
    errBtn2: string
    preventWarning: string
    errPreventWarning: string
}

export default class AddQuestionDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            modified: false,
            title: props.question.Title || "",
            errTitle: null,
            question: props.question.Body || "",
            errQuestion: null,
            btn1: props.question.BtnLabel1 || "",
            errBtn1: null,
            btn2: props.question.BtnLabel2 || "",
            errBtn2: null,
            preventWarning: props.question.NotifyMsg || "",
            errPreventWarning: null
        }
        autobind(this)
    }

    handleSave() {
        if (!this.checkValidate()) return
        const question = _.cloneDeep(this.props.question)
        if (this.state.modified) {
            question.ModifiedDate = moment().utc().format()
        }
        question.Title = this.state.title.trim()
        question.Body = this.state.question.trim()
        question.BtnLabel1 = this.state.btn1.trim()
        question.BtnLabel2 = this.state.btn2.trim()
        question.NotifyMsg = this.state.preventWarning ? this.state.preventWarning.trim() : null
        this.props.handleUpdate(question)
    }

    checkValidate() {
        let isValid = true
        if (!this.state.title.trim()) {
            this.setState({ errTitle: strings.This_field_is_required })
            isValid = false
        }
        else if (this.state.title.trim().length > 25) {
            this.setState({ errTitle: strings.formatString(strings.max_x_chars, 25) as string })
            isValid = false
        }
        else {
            this.setState({ errTitle: null })
        }

        if (!this.state.question.trim()) {
            this.setState({ errQuestion: strings.This_field_is_required })
            isValid = false
        }
        else {
            this.setState({ errQuestion: null })
        }

        if (!this.state.btn1.trim()) {
            this.setState({ errBtn1: strings.This_field_is_required })
            isValid = false
        }
        else if (this.state.btn1.trim().length > 15) {
            this.setState({ errBtn1: strings.formatString(strings.max_x_chars, 15) as string })
            isValid = false
        }
        else {
            this.setState({ errBtn1: null })
        }

        if (!this.state.btn2.trim()) {
            this.setState({ errBtn2: strings.This_field_is_required })
            isValid = false
        }
        else if (this.state.btn2.trim().length > 15) {
            this.setState({ errBtn2: strings.formatString(strings.max_x_chars, 15) as string })
            isValid = false
        }
        else {
            this.setState({ errBtn2: null })
        }

        if ((this.props.question.Btn1Action === -1 || this.props.question.Btn2Action === -1)) {
            if (!this.state.preventWarning.trim()) {
                this.setState({ errPreventWarning: strings.This_field_is_required })
                isValid = false
            }
            else {
                this.setState({ errPreventWarning: null })
            }
        }
        return isValid
    }

    render() {
        return (
            <Dialog
                open
                title={EnumValues.getNameFromValue(ELanguage, this.props.question.Language)}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={[
                    <FlatButton key="cancel" label={strings.CANCEL} secondary onTouchTap={this.props.handleClose} />,
                    <FlatButton key="save" label={strings.SAVE} primary onTouchTap={this.handleSave} />
                ]}
                autoScrollBodyContent
            >
                <hr />
                <div style={{ paddingLeft: 15, paddingRight: 15 }}>
                    <TextField
                        name="title"
                        floatingLabelText={strings.Title}
                        value={this.state.title}
                        onChange={(e, value) => this.setState({ title: value, modified: true }, () => this.checkValidate())}
                        errorText={this.state.errTitle}
                        errorStyle={{ position: "absolute", bottom: -10 }}
                    />
                    <HTMLEditText
                        identifier="QuestionEditor"
                        style={{ marginTop: 25 }}
                        title={strings.Question}
                        value={this.state.question}
                        handleChange={value => this.setState({ question: value, modified: true }, () => this.checkValidate())}
                        error={this.state.errQuestion}
                    />
                    <div style={{ marginTop: 25 }}>
                        <div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.3)" }}>
                            {strings.Button_Labels}
                        </div>
                        <div style={{ marginLeft: 20 }}>
                            <div style={{ display: "flex", marginTop: -10 }} >
                                <TextField
                                    name="btn1"
                                    floatingLabelText=""
                                    style={{ width: 125 }}
                                    value={this.state.btn1}
                                    onChange={(e, value) => this.setState({ btn1: value, modified: true }, () => this.checkValidate())}
                                    errorText={this.state.errBtn1}
                                    errorStyle={{ position: "absolute", bottom: -10 }}
                                />
                                <div style={{ marginTop: 25, marginLeft: 10 }}>{strings.Button1}</div>
                            </div>
                            <div style={{ display: "flex" }}>
                                <TextField
                                    name="btn2"
                                    floatingLabelText=""
                                    style={{ width: 125 }}
                                    value={this.state.btn2}
                                    onChange={(e, value) => this.setState({ btn2: value, modified: true }, () => this.checkValidate())}
                                    errorText={this.state.errBtn2}
                                    errorStyle={{ position: "absolute", bottom: -10 }}
                                />
                                <div style={{ marginTop: 25, marginLeft: 10 }}>{strings.Button2}</div>
                            </div>
                        </div>
                    </div>
                    {(this.props.question.Btn1Action === -1 || this.props.question.Btn2Action === -1) &&
                        <TextField
                            name="preventWarning"
                            multiLine
                            fullWidth
                            rows={2}
                            rowsMax={2}
                            floatingLabelText={strings.Prevent_Warning}
                            value={this.state.preventWarning}
                            onChange={(e, value) => this.setState({ preventWarning: value, modified: true }, () => this.setState({ preventWarning: value }, () => this.checkValidate()))}
                            errorText={this.state.errPreventWarning}
                            errorStyle={{ position: "absolute", bottom: -10 }}
                        />
                    }
                </div>
            </Dialog >
        )
    }
}